import '@/ui-kit/components/Input/Input.css';
import { cn } from '@ui-kit/utils';
import type { ComponentProps } from 'react';

export type InputProps = ComponentProps<'input'> & {
  label: string;
  name: string;
  id?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  error?: boolean;
  errorMessage?: string;
};

export const Input = ({
  name,
  label,
  className,
  disabled = false,
  errorMessage = '',
  placeholder = ' ',
  id = name,
  error = Boolean(errorMessage),
  ...restProps
}: InputProps) => {
  if (placeholder === '') {
    throw new Error('Placeholder must not be an empty string.');
  }

  const showErrorMessage = !disabled && error && errorMessage;
  const errorMessageId = `${id}-error-message`;

  return (
    <div className={cn('flex flex-col text-left', className)}>
      <div className="ui-kit-input-container relative flex h-12 grow lg:h-13">
        <input
          id={id}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          aria-invalid={error}
          aria-errormessage={showErrorMessage ? errorMessageId : undefined}
          className="caret-text-brand min-w-0 grow rounded-sm border-none bg-transparent px-4 py-3.5 text-[length:inherit] leading-[inherit] font-[weight:inherit] tracking-[inherit]"
          {...restProps}
        />

        <label htmlFor={id} className="text-text-subtle pointer-events-none absolute top-0 left-0 px-1">
          {label}
        </label>

        <fieldset aria-hidden="true">
          <legend>
            <span>{label}</span>
          </legend>
        </fieldset>
      </div>

      {!!showErrorMessage && (
        <p id={errorMessageId} className="text-caption-semibold text-text-error mt-1 ml-4">
          {errorMessage}
        </p>
      )}
    </div>
  );
};
